module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/3_59a6582ac7a284e2286a27c122b7e41c.png";